// No `toJSON()`: the archival endpoint carries no body.
class ArchiveDocumentTemplate {
	constructor(
		public readonly organizationId: number,
		public readonly templateId: number,
	) {
		Object.freeze(this);
	}
}

export default ArchiveDocumentTemplate;
